import { useState } from 'react';
import { Field} from "formik";
import Select from "react-select";
import Translator from "../../../../components/helpers/Translator";
import AppModal from "../../../../components/Modal/AppModal";
import { AppRemixIcon } from '@/layout/AppComponents';

const BlockHSFrameworkProgress = props => {
    const { index, arrayHelpers, values, disabled, report, onLevelUp } = props;
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showLevelUpModal, setShowLevelUpModal] = useState(false);
    const [levelUpOption, setLevelUpOption] = useState(null);

    const remove = () => {
        arrayHelpers.remove(index)
        setShowDeleteModal(false)
    }

    const handleLevelUp = async() => {
        try {
            const pgID = levelUpOption;
            setLevelUpOption(null)
            await onLevelUp({values: values.hsFrameworkProgress[index], plantGroupID: pgID, type: 'hsFrameworkProgress'})
            setShowLevelUpModal(false)
        } catch (err) {}
    }

    return (
        <div className="row mb-3" key={index}>
            <div className="col-12">
                <div className="card sr-header">
                    <div className="card-header">
                        <span className="text-uppercase"><b><Translator file='module-saicaReports' name='framework.progress' /></b></span> Nº {index+1} {values.hsFrameworkProgress[index].originTier && <span className="btn btn-xs btn-warning" style={{marginLeft: '10px'}}><Translator file='module-saicaReports' name='from' />: <b>{values.hsFrameworkProgress[index].originTier}</b></span>}
                        <span className={`float-right btn btn-danger btn-sm pointer ${disabled && 'disabled'}`} onClick={() => !disabled && setShowDeleteModal(true)}><AppRemixIcon icon="delete-bin" /></span>
                        <span className={`float-right btn btn-info btn-sm pointer mr-2 ${!report.levelUpPermissions && 'disabled'}`} onClick={() => report.levelUpPermissions && setShowLevelUpModal(true)}><AppRemixIcon icon="corner-right-up" /></span>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-10">
                                <div className="text-bold">
                                    <Translator file='module-saicaReports' name='goal.include.actions.standards.framework' />
                                </div>
                            </div>
                            <div className="col-2">
                                {values.hsFrameworkProgress[index].obligationID && (
                                    <div className="text-bold float-right">
                                        ID: {values.hsFrameworkProgress[index].obligationID}
                                    </div>
                                )}
                            </div>
                        </div>
                        <br/>
                        <div>
                            <div className="row">
                                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                                    <label className="col-form-label">
                                        <Translator file='module-saicaReports' name='action' />
                                    </label>
                                </div>
                                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                                    <Field name={`hsFrameworkProgress[${index}].action`} className={"form-control mb-2"} disabled={disabled} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                                    <label className="col-form-label">
                                        <Translator file='module-saicaReports' name='standard.n' />
                                    </label>
                                </div>
                                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                                    <Field name={`hsFrameworkProgress[${index}].standard`} className={"form-control mb-2"} disabled={disabled} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                                    <label className="col-form-label">
                                        <Translator file='module-saicaReports' name='comments' />
                                    </label>
                                </div>
                                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                                    <Field name={`hsFrameworkProgress[${index}].comments`} className={"form-control mb-2"} disabled={disabled} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AppModal show={showDeleteModal} onConfirm={() => remove()} onClose={() => setShowDeleteModal(false)} />
            <AppModal show={showLevelUpModal}
                          isConfirmBtn={false}
                          isCancelBtn={true}
                          cancelBtnText={<Translator file='module-saicaReports' name='cancel' />}
                          title={<Translator file='module-saicaReports' name='level.up' />}
                          onClose={() => {
                              setShowLevelUpModal(false)
                          }}
            >
                <p>
                    <Translator file='module-saicaReports' name='want.level.up.current.state.block' />
                </p>
                <p>
                    <Translator file='module-saicaReports' name='select.tier.level.send' />
                </p>
                {report.levelUpPermissions && (
                    <Select className="mb-3"
                            options={report.levelUpPermissions}
                            onChange={opt => setLevelUpOption(opt.value)}
                            value={levelUpOption ? report.levelUpPermissions.find(p => p.value === levelUpOption) : null}
                    />
                )}
                <span className={`btn btn-info btn-block ${!levelUpOption && 'disabled'}`} onClick={() => levelUpOption && handleLevelUp()}><Translator file='module-saicaReports' name='level.up' /></span>
            </AppModal>
        </div>
    );
};

export default BlockHSFrameworkProgress;
import styled from "styled-components";
import Accordion from "react-bootstrap/Accordion";

/** Wrapper que “convierte” el Accordion Bootstrap en un menú lateral */
const SidebarAccordion = styled(Accordion)`
  /* Evitar bordes/estética acordeón */
  .accordion-item {
    border: 0;
    background: transparent;
  }

  .accordion-header {
    margin: 0;
  }

  /* Header bootstrap: es un button */
  .accordion-button {
    background: transparent !important;
    box-shadow: none !important;
    border: 0 !important;

    padding: 10px 12px; /* estética sidebar */
    color: inherit !important;

    /* importante para que el contenido que metas (SidebarButton) no se descoloque */
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .accordion-button:not(.collapsed) {
    background: transparent !important;
    color: inherit !important;
  }

  /* Quita el “focus ring” de bootstrap si te molesta en sidebar */
  .accordion-button:focus {
    box-shadow: none !important;
  }

  .accordion-body {
    padding: 6px 0 10px 0;
  }

  /* Icono flecha (caret) */
  .accordion-button::after {
    opacity: 0.75;
  }
`;

/** Lista de hijos dentro del body */
const ChildList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

/** Cada fila hija */
const ChildRow = styled.li`
  margin: 0;
`;

/**
 * Clickable wrapper para mantener la estética de menú.
 * Uso <button> para accesibilidad y evitar warnings.
 */
const ChildAction = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: transparent;
  border: 0;
  cursor: pointer;

  padding: 8px 12px 8px 44px; /* indentado (ajusta si tus iconos cambian) */
  text-align: left;
  color: inherit;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  &:focus {
    outline: none;
  }
`;

const ChildLabel = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 22px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;

  font-size: 12px;
  line-height: 18px;

  background: rgba(0, 0, 0, 0.08);
`;
